import React from "react";
import { OutlineBadge } from "@app/shared/OutlineBadge";
import { findTierByIndex, resolveBadgeColor, resolveTierLabel } from "@app/shared/confidence-tier/confidenceTierLookup";
import { useConfidenceTierDefinitions } from "@app/shared/confidence-tier/useConfidenceTierDefinitions";

interface ConfidenceTierBadgeProps {
  /** 0-based tier index; 0 is a valid tier, so never check it for truthiness. */
  confidenceTier: number | null | undefined;
  testId?: string;
}

/** Renders nothing without a tier or while the definitions load. */
export const ConfidenceTierBadge: React.FC<ConfidenceTierBadgeProps> = ({ confidenceTier, testId }) => {
  const { definitions, isPending } = useConfidenceTierDefinitions();

  if (confidenceTier == null || isPending) {
    return null;
  }

  const tier = findTierByIndex(definitions, confidenceTier);

  return (
    <OutlineBadge color={resolveBadgeColor(tier?.badgeColor)} testId={testId}>
      {resolveTierLabel(tier?.label)}
    </OutlineBadge>
  );
};
